module.exports = __webpack_public_path__ + "static/media/icon_qr_scan.ef3bdd72.png";